import { defineMessages } from 'react-intl'
import { Maybe, User } from '../../common/types'
import { Operator } from './types'

export const userMessages = defineMessages({
  operatorMe: {
    id: 'user.operatorMe',
    defaultMessage: 'Minä',
  },
})

export function getOperatorLabelFromId(
  operatorId: Maybe<number>,
  user: Maybe<User>,
  operators: Maybe<Operator[]>,
  translateMessage: (messageId: string) => string
): string {
  if (operatorId && user && operators) {
    if (operatorId !== user.user_id) {
      const operator = operators.find(operator => operatorId === operator.id)
      return operator ? operator.name : ''
    } else {
      return translateMessage(userMessages.operatorMe.id)
    }
  }

  return ''
}
